import React from 'react'

import "./HomeSection4.css"
import homePImg from "../../../../assets/imgs/homePImg.png"

function HomeSection4() {
  return (
    <div className='hs1 hs4'>
    <span className='hs1-head'>PRODUCTS</span>
   <span className='hs1-title'>Sync Verse Products</span>
   <div className='hs4-inner'>
    <div className='hs4-left'>
        <img src={homePImg} alt="" />
        <div></div>
    </div>
    <div className='hs4-right'>
         <span>6 Combo Pack</span>
         <p>Lorem ipsum dolor sit amet consectetur. Ornare mi duis aliquam amet arcu ipsum egestas. Pulvinar quis libero sed neque. Tristique semper velit tempus sit. Posuere massa nunc nisl nulla et quisque. Lorem ipsum dolor sit amet consectetur. Ornare mi duis aliquam amet arcu ipsum egestas. Pulvinar quis libero sed neque. Tristique semper velit tempus sit. Posuere massa nunc nisl nulla et quisque.</p>

    </div>


    </div>
    </div>
  )
}

export default HomeSection4
